import "./RinnaiWaterHeaterService.module.css";
import Header from "@/reusable_sections/Header";
import RinnaiHero from "./sections/RinnaiHero";
import RinnaiServices from "./sections/RinnaiServices";
import RinnaiTrust from "./sections/RinnaiTrust";
import Footer from "@/reusable_sections/Footer";
export default function RinnaiWaterHeaterServicePage() {
  return <div>
      <Header />
      <RinnaiHero />
      <RinnaiServices />
      <RinnaiTrust />
      <Footer />
    </div>;
}